import { memo, useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import NavGroup from './NavGroup';
import menuItem from '@/app/menu-items';
import menuItemEcoles from '@/app/menu-items/indexEcoles';
import menuItemInstitutos from '@/app/menu-items/indexInstitutos';
import indexEtudiants from '@/app/menu-items/indexEtudiants';
import indexProfesseurs from '@/app/menu-items/indexProfesseurs';
import { useSelector } from '@/app/store';

const MenuList = () => {
    const { paramMemoire } = useSelector((state) => state.diversParametersRedux);

    const [utilisateurConnect, setUtilisateurConnect] = useState(0);
    const [typeUtilisateur, setTypeUtilisateur] = useState(0);
    const [universityOuCollege, setUniversityOuCollege] = useState(0);
    const [rolesistema, setroleSistea] = useState(0);


    useEffect(() => {

        paramMemoire.map((item) => {

         setUniversityOuCollege(item.universityOuCollege);
            setTypeUtilisateur(item.typeUtilisateur);
            setUtilisateurConnect(item.isLoggedIn2 ? 1 : 0);
            setroleSistea(item.role)

        });
    }, [paramMemoire, rolesistema, typeUtilisateur, universityOuCollege]);

    // Simplify the rendering of nav items by creating a function
    const renderNavItems = (items) => items.map(item => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return <Typography key={item.id} variant="h6" color="error" align="center">Menu Items Error</Typography>;
        }
    });
    
    const getNavItems = () => {
        if (utilisateurConnect > 0) {
            if ((typeUtilisateur === 1 && (Number(rolesistema)  <5  || Number(rolesistema)  === 101 ))) {
                if (Number(universityOuCollege) === 1) return renderNavItems(menuItem.items);
                if (Number(universityOuCollege) === 2) return renderNavItems(menuItemInstitutos.items);
                if (Number(universityOuCollege) === 3) return renderNavItems(menuItemEcoles.items);
            } else if (typeUtilisateur === 2) {
                return renderNavItems(indexProfesseurs.items);
            } else if (typeUtilisateur >= 3) {
                return renderNavItems(indexEtudiants.items);
            }
        }
        return null;  // Return null if none of the conditions match
    };

    
    return <>{getNavItems()}</>;

};

export default memo(MenuList);
